export default __webpack_public_path__ + "static/media/OutdoorActivities-hover.5c9d1059.svg";